module.exports = __webpack_public_path__ + "media/images/building-1335502e5f9c1baa032894ca87a858dd.svg";